/**
 * factfind.service.ts — Layer 3: Financial & Fact Find Domain
 *
 * Internal (authenticated) fact-find and financial-summary API calls. For the
 * unauthenticated shared-link OTP flow, see factFindAccess.service.ts.
 */

import { getRequest, putRequest, postRequest, postRawResponse } from './http.service';
import {
  URL_FACTFIND_ACTIVE,
  URL_FACTFIND_BY_CLIENT,
  URL_FACTFIND_HISTORY,
  URL_PROSPO_FACTFIND_EXPORT,
  URL_PROSPO_FACTFIND_UPDATE_GRAPH,
  URL_FINANCIAL_SUMMARY,
  URL_FINANCIAL_LIFE_EVENTS,
  URL_FINANCIAL_RECALCULATE,
} from './url.service';

/** Get the currently-active fact find for a client */
export const fetchActiveFactFind = (clientId: string, signal?: AbortSignal) =>
  getRequest(URL_FACTFIND_ACTIVE(clientId), signal);

/** Get the full fact-find version history for a client */
export const fetchFactFindHistory = (clientId: string) =>
  getRequest(URL_FACTFIND_HISTORY(clientId));

/** Save fact-find data as a new version */
export const saveFactFind = (clientId: string, payload: Record<string, unknown>) =>
  putRequest(URL_FACTFIND_BY_CLIENT(clientId), payload);

/** Push changed fields to the knowledge-graph update pipeline */
export const updateFactFindGraph = (payload: Record<string, unknown>) =>
  postRequest(URL_PROSPO_FACTFIND_UPDATE_GRAPH, payload);

/** Export a fact find as a PDF/DOCX blob */
export const exportFactFind = (payload: Record<string, unknown>) =>
  postRawResponse(URL_PROSPO_FACTFIND_EXPORT, payload);

/** Get the financial summary (yearly assets/liabilities/income/expense) for a client */
export const fetchFinancialSummary = (clientId: string) =>
  getRequest(URL_FINANCIAL_SUMMARY(clientId));

/** Get life events used for cashflow projections */
export const fetchLifeEvents = (clientId: string) =>
  getRequest(URL_FINANCIAL_LIFE_EVENTS(clientId));

/** Trigger a fresh financial projection from the latest fact find */
export const recalculateFinancials = (clientId: string) =>
  postRequest(URL_FINANCIAL_RECALCULATE(clientId));
